__turbopack_context__.v({
  "icon": "icon-module__prgaGW__icon",
});
